import { useMemo } from 'react';
import type { TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import { useGetPolylineQuery } from '../redux/mapsApi';
import type { LngLat } from '../types/Geo';
import decodeTrailPolyline from '../utils/decodeTrailPolyline';

/**
 * A trail's line, from the search result's own polyline when it has one and fetched otherwise. Undefined until it is
 * available, or without a trail.
 */
const useTrailPolylineCoordinates = (trail?: Pick<TrailSearchResult, 'ID' | 'polyline'>): LngLat[] | undefined => {
  const trailId = trail?.ID;
  const polyline = trail?.polyline;
  // `currentData` rather than `data`, which keeps the previous trail's line until the new one loads
  const { currentData: fetchedCoordinates } = useGetPolylineQuery({ trailId: trailId ?? 0 }, { skip: trailId === undefined || Boolean(polyline) });

  // A new array each render would rebuild the line and re-upload it to the map source
  const decodedCoordinates = useMemo(() => (polyline ? decodeTrailPolyline(polyline) : undefined), [polyline]);

  return decodedCoordinates ?? fetchedCoordinates;
};

export default useTrailPolylineCoordinates;
